// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"pISq54ARK4wJAIN4"};